"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.join");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.constructor");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.renderBmNumberInputItem = exports.registerNumberInputElement = exports.BmNumberInputFieldElement = void 0;

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _isNan = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/number/is-nan"));

var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-float"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _element = require("@blue/element");

var _mask = require("@blue/services/utils/mask");

var _inputFieldRenderer = require("../../../../core/render/items/input-engine/input-field-renderer");

var _fieldRenderer = require("../../../../core/render/items/input-engine/field-renderer");

var _maskedTextInput = require("../../../../core/render/items/input-engine/inputs/masked-text-input");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)([" <bm-number-input-field .info=\"", "\"></bm-number-input-field> "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<style>\n\t\t\t\tbm-masked-text-input {\n\t\t\t\t\t--bm-masked-input-bold: bold;\n\t\t\t\t}\n\t\t\t</style>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t", "\n\t\t\t<bm-masked-text-input\n\t\t\t\t.name=\"", "\"\n\t\t\t\t.disabled=\"", "\"\n\t\t\t\t.readonly=\"", "\"\n\t\t\t\t.touched=\"", "\"\n\t\t\t\t.dirty=\"", "\"\n\t\t\t\t.value=\"", "\"\n\t\t\t\t.mask=\"", "\"\n\t\t\t\t.dataQeId=\"", "\"\n\t\t\t\t.clearMalformedValues=\"", "\"\n\t\t\t\t.cacheNextValue=\"", "\"\n\t\t\t\t@bm-form-event=\"", "\"\n\t\t\t></bm-masked-text-input>\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function getFractionVal(num) {
  var _context, _context2;

  var fraction = (0, _map.default)(_context = (0, _filter.default)(_context2 = new Intl.NumberFormat().formatToParts(num)).call(_context2, function (p) {
    return p.type === 'fraction';
  })).call(_context, function (p) {
    return p.value;
  })[0];
  return fraction;
}

var BmNumberInputFieldElement = /*#__PURE__*/function (_BmInputFieldElement) {
  (0, _inherits2.default)(BmNumberInputFieldElement, _BmInputFieldElement);

  var _super = (0, _createSuper2.default)(BmNumberInputFieldElement);

  function BmNumberInputFieldElement() {
    var _context3;

    var _this;

    (0, _classCallCheck2.default)(this, BmNumberInputFieldElement);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context3 = [this]).call(_context3, args));
    _this.parts = [];
    _this.mask = [];
    _this.serializedMask = [];
    return _this;
  }

  (0, _createClass2.default)(BmNumberInputFieldElement, [{
    key: "shouldUpdate",
    value: function shouldUpdate(props) {
      if (props.has('info')) {
        var prevInfo = props.get('info');

        if ((prevInfo === null || prevInfo === void 0 ? void 0 : prevInfo.value) && this.value) {
          var prevFraction = getFractionVal(prevInfo.value);
          var currFraction = getFractionVal(this.value);

          if (prevFraction && (!currFraction || currFraction.length < prevFraction.length - 1)) {
            return false;
          }
        }
      }

      return (0, _get2.default)((0, _getPrototypeOf2.default)(BmNumberInputFieldElement.prototype), "shouldUpdate", this).call(this, props);
    }
  }, {
    key: "_renderInput",
    value: function _renderInput() {
      this.formatter = this._makeFormatter(this.info.options.mask);

      var i18nDecimal = this._getI18nDecimal(this.info.options.mask.options.locale);

      this.mask = this._makeMask(this.formatter, this.value);
      this.serializedMask = (0, _mask.serialize)(this.mask);
      var value = '';

      if (this.info.value) {
        value = this.info.options.mask.options.style === 'percent' ? this.info.value * 100 : this.info.value;
        value = value.toString().replace('.', i18nDecimal);
      }

      return this.html(_templateObject(), this._setCustomProps(), this.info.name, Boolean(this.info.disabled), this.readonly, Boolean(this.info.touched), Boolean(this.info.dirty), value, this.serializedMask, this.info.options.dataQeId, false, true, this.handleBmFormEvent);
    }
  }, {
    key: "handleBmFormEvent",
    value: function handleBmFormEvent(evt) {
      switch (evt.detail.type) {
        case 'changed':
          this.handleBmFormChangeEvent(evt);
          break;

        default:
          break;
      }
    }
  }, {
    key: "handleBmFormChangeEvent",
    value: function handleBmFormChangeEvent(evt) {
      var _context4;

      var currentVal = evt.detail.data.currentValue;

      var decimalPartValue = this._getI18nDecimal(this.formatter.resolvedOptions().locale);

      var _this$formatter$resol = this.formatter.resolvedOptions(),
          maximumFractionDigits = _this$formatter$resol.maximumFractionDigits;

      currentVal = (0, _map.default)(_context4 = currentVal.split(decimalPartValue)).call(_context4, function (val, idx) {
        return idx === 1 ? val.substring(0, maximumFractionDigits) : val;
      }).join('.');
      var parsedValue = (0, _parseFloat2.default)(currentVal);
      var nextValue = (0, _isNan.default)(parsedValue) ? null : parsedValue;

      if (nextValue && this.info.options.mask.options.style === 'percent') {
        nextValue /= 100;
      }

      if (nextValue === this.value) {
        evt.stopPropagation();
      } else {
        evt.detail.data.currentValue = nextValue;
      }
    }
  }, {
    key: "_getI18nDecimal",
    value: function _getI18nDecimal(locale) {
      var _context5;

      return (0, _find.default)(_context5 = new Intl.NumberFormat(locale).formatToParts(0.1)).call(_context5, function (part) {
        return part.type === 'decimal';
      }).value;
    }
  }, {
    key: "_makeFormatter",
    value: function _makeFormatter(maskOptions) {
      var _maskOptions$options = maskOptions.options,
          locale = _maskOptions$options.locale,
          style = _maskOptions$options.style,
          currency = _maskOptions$options.currency,
          format = (0, _objectWithoutProperties2.default)(_maskOptions$options, ["locale", "style", "currency"]);
      var _locale = Intl.NumberFormat.supportedLocalesOf(locale)[0];
      var formatOptions = (0, _objectSpread2.default)({
        style: style,
        currency: style === 'currency' ? currency : undefined
      }, format);
      return new Intl.NumberFormat(_locale, formatOptions);
    }
  }, {
    key: "_makeMask",
    value: function _makeMask(formatter, val) {
      var _context6;

      var _val = val || 0;

      this.parts = formatter.formatToParts(_val);
      var mask = (0, _reduce.default)(_context6 = this.parts).call(_context6, function (acc, part) {
        var vals;

        switch (part.type) {
          case 'fraction':
          case 'integer':
            {
              var _context7;

              vals = (0, _map.default)(_context7 = part.value.split('')).call(_context7, function () {
                return new RegExp(/\d/);
              });
              break;
            }

          case 'decimal':
            vals = new RegExp("\\".concat(part.value));
            break;

          default:
            vals = part.value.replace(/\s/, ' ');
            break;
        }

        return (0, _concat.default)(acc).call(acc, vals);
      }, []);
      if (formatter.resolvedOptions().minimumFractionDigits > 0) mask.push(/0/);
      return mask;
    }
  }, {
    key: "_setCustomProps",
    value: function _setCustomProps() {
      return this.info.options.styles === 'bold' ? this.html(_templateObject2()) : null;
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-number-input-field';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        info: {
          type: Object,
          attribute: false,
          reflect: true
        }
      };
    }
  }]);
  return BmNumberInputFieldElement;
}(_inputFieldRenderer.BmInputFieldElement);

exports.BmNumberInputFieldElement = BmNumberInputFieldElement;

var registerNumberInputElement = function registerNumberInputElement() {
  (0, _element.register)(_fieldRenderer.BmField);
  (0, _maskedTextInput.registerBmMaskedTextInput)();
  (0, _element.register)(BmNumberInputFieldElement);
};

exports.registerNumberInputElement = registerNumberInputElement;

var renderBmNumberInputItem = function renderBmNumberInputItem(info) {
  return (0, _element.html)(_templateObject3(), info);
};

exports.renderBmNumberInputItem = renderBmNumberInputItem;
